// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:40:50

export default {
  "id": "pull-the-pins",
  "slug": "pull-the-pins",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/be1e7318706f483ea492bd0017029fa6-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/be1e7318706f483ea492bd0017029fa6/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Pull The Pins",
      "description": "Pull the Pins is a strategic puzzle game where you must carefully pull pins in the correct order to rescue a young boy and make him reach his brother. Each decision matters, as a wrong move could lead to failure. Plan your actions wisely and use problem-solving skills to ensure a successful rescue.",
      "instructions": "Tap or mouse click to play!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "rescue",
        "sliding-puzzle"
      ]
    },
    "zh-CN": {
      "title": "拉出销钉",
      "description": "拉栓解谜是一款策略性益智游戏，你必须小心翼翼地按正确顺序拉动栓子，救出一个小男孩，让他到达他哥哥那里。每个决定都很重要，因为一个错误的动作可能导致失败。明智地规划你的行动，运用解决问题的技巧，以确保成功的救援。",
      "instructions": "点击或鼠标左键开始游戏！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "营救",
        "滑动拼图"
      ]
    },
    "zh-TW": {
      "title": "拉針",
      "description": "拉針是策略謎題遊戲，你必須謹慎地按正確順序拉動針，以救援一個小男孩並讓他趕上他的哥哥。每個決定都相當重要，因為一個錯誤的動作可能導致失敗。明智地規劃你的行動，並使用問題解決技巧來保證救援成功。",
      "instructions": "點擊或滑鼠點擊開始遊戲！",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "救援",
        "滑動拼圖"
      ]
    },
    "zh-HK": {
      "title": "拉針",
      "description": "拉針遊戲是一個策略謎題遊戲，玩家必須謹慎地以正確的順序拉動針，以救出一個年輕男孩並讓他與哥哥會合。每個決定都至關重要，因為錯誤的動作可能導致失敗。謹慎規劃行動並運用解謎技巧，確保救援成功。",
      "instructions": "按鍵或滑鼠點擊開始遊戲！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "拯救",
        "滑動拼圖"
      ]
    },
    "ja": {
      "title": "ピンを引く",
      "description": "ピンを引くのは、幼い少年を救出し、彼が兄に会うためにピンを正しい順番で引く必要がある戦略的なパズルゲームです。それぞれの決定が重要であり、間違った動きは失敗につながる可能性があります。行動をよく計画し、問題解決スキルを活かして成功の救出を確保してください。",
      "instructions": "タップまたはマウスクリックで遊ぶ！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "救出",
        "スライディングパズル"
      ]
    },
    "ko": {
      "title": "핀을 당겨라",
      "description": "핀 풀(Pull the Pins)은 전략적 퍼즐 게임으로, 어린 소년을 구출하고 그가 형제와 만날 수 있도록 올바른 순서로 핀을 당겨야 합니다. 각 결정이 중요하며, 잘못된 움직임은 실패로 이어질 수 있습니다. 행동을 신중하게 계획하고 문제 해결 능력을 사용하여 성공적인 구출을 보장하세요.",
      "instructions": "락이나 마우스 클릭으로 게임 시작!",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "구조",
        "슬라이딩 퍼즐"
      ]
    },
    "fr": {
      "title": "Pousser les boules à neige",
      "description": "Tirer les Épingles est un jeu de puzzle stratégique où vous devez tirer les épingles dans le bon ordre pour sauver un jeune garçon et le faire atteindre son frère. Chaque décision compte, car un mauvais coup pourrait conduire à l'échec. Planifiez vos actions intelligemment et utilisez des compétences en résolution de problèmes pour assurer une réussite réussie.",
      "instructions": "Tapez ou cliquez avec la souris pour jouer !",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "Sauvetage",
        "puzzle glissant"
      ]
    }
  }
};
